{
  "toolbar_action_disabled": "Несовместимый элемент разметки",
  "edit": "Редактировать",
  "delete": "Удалить"
}
